var MAX = Number.MAX_VALUE;
function getSpaceLimits({ space, includes }) {
	let minArea = 0;
	let maxArea = 0;
	let minX = 0;
	let maxX = 0;
	let minY = 0;
	let maxY = MAX;
	let minZ = 0;
	let maxZ = MAX;
	const rules = includes && includes.length > 0 ? includes : [space];
	for (const rule of rules) {
		minArea += rule.attributes.area ? rule.attributes.area[0] : 0;
		maxArea += rule.attributes.area ? rule.attributes.area[1] : 0;
		minX += rule.attributes.sizeX ? rule.attributes.sizeX[0] : 0;
		maxX += rule.attributes.sizeX ? rule.attributes.sizeX[1] : 0;
		minY = rule.attributes.sizeY ? Math.max(rule.attributes.sizeY[0], minY) : minY;
		maxY = rule.attributes.sizeY ? Math.min(rule.attributes.sizeY[1], maxY) : maxY;
		minZ = rule.attributes.sizeZ ? Math.max(rule.attributes.sizeZ[0], minZ) : minZ;
		maxZ = rule.attributes.sizeZ ? Math.min(rule.attributes.sizeZ[1], maxZ) : maxZ;
	}
	if (maxArea === 0) maxArea = MAX;
	if (maxX === 0) maxX = MAX;
	if (space.consolidationType) {
		if (space.attributes.area) {
			minArea = space.attributes.area[0];
			maxArea = space.attributes.area[1];
		}
		if (space.attributes.sizeX) {
			minX = space.attributes.sizeX[0];
			maxX = space.attributes.sizeX[1];
		}
		if (space.attributes.sizeY) {
			minY = space.attributes.sizeY[0];
			maxY = space.attributes.sizeY[1];
		}
		if (space.attributes.sizeZ) {
			minZ = space.attributes.sizeZ[0];
			maxZ = space.attributes.sizeZ[1];
		}
	}
	return {
		area: [minArea, maxArea],
		sizeX: [minX, maxX],
		sizeY: [minY, maxY],
		sizeZ: [minZ, maxZ]
	};
}
export { getSpaceLimits };

//# sourceMappingURL=index95.js.map